import { render, staticRenderFns } from "./child_header.vue?vue&type=template&id=01db311d&scoped=true&%23header=true"
import script from "./child_header.vue?vue&type=script&lang=js"
export * from "./child_header.vue?vue&type=script&lang=js"
import style0 from "./child_header.vue?vue&type=style&index=0&id=01db311d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db311d",
  null
  
)

export default component.exports